import { FC, useMemo } from 'react';
import { contentIcons } from '../../icons/content';
import { systemIcons } from '../../icons/system';

export const icons = {
  ...systemIcons,
  ...contentIcons,
};

export type IconName = keyof typeof icons;

export type IconProps = {
  /**
   * Name of the icon
   */
  name: IconName;
  /**
   * Flag for inline icon
   */
  inline?: boolean;
};

export const Icon: FC<IconProps> = ({ name, inline }) => {
  const isSystemIcon = useMemo((): boolean => {
    const matches = Object.keys(systemIcons).find(
      (systemIcon) => systemIcon === name,
    );
    return !!matches;
  }, [name]);

  const IconByName = useMemo(() => icons[name], [name]);

  if (typeof IconByName === 'undefined') return null;

  return (
    <IconByName
      className={`max-h-full w-auto ${inline ? 'inline' : 'block m-auto'} ${
        isSystemIcon ? 'fill-current' : ''
      }`}
      data-testid={`${isSystemIcon ? "system" : 'content'}-icon`}
    />
  );
};
